import { render, staticRenderFns } from "./QuestionnairePageTable.vue?vue&type=template&id=45568986&scoped=true&"
import script from "./QuestionnairePageTable.vue?vue&type=script&lang=ts&"
export * from "./QuestionnairePageTable.vue?vue&type=script&lang=ts&"
import style0 from "./QuestionnairePageTable.vue?vue&type=style&index=0&id=45568986&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45568986",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VSimpleTable})
